import React, { useEffect, useState } from "react";
import authService from "../services/authService";
import { useNavigate } from "react-router-dom";
import { BarChart3 } from "lucide-react";
import { PersonAdd, Hdd } from "react-bootstrap-icons";
import NotificationPanel from "./NotificationPanel";
const Greeting = ({ showNotifications = true }) => {
  const [greeting, setGreeting] = useState("Hello, there!");
  const navigate = useNavigate();
  const isAuthenticated = authService.isAuthenticated();
  const isStaff = authService.isStaff();
  const isTherapist = authService.isTherapist();

  useEffect(() => {
    if (isAuthenticated) {
      const firstName = localStorage.getItem("first_name");
      setGreeting(`Hello, ${firstName}!`);
    }
  }, [isAuthenticated]);

  const handleNavigate = () => {
    navigate("/");
  };

  const handleMetricsClick = () => {
    navigate("/metrics"); // Adjust this path as needed
  };

  return (
    <div className="d-flex justify-content-between align-items-center mt-3 px-3">
      <div className="d-flex align-items-center gap-3">
        {isStaff && (
          <>
          <BarChart3
            className="cursor-pointer text-primary hover:text-primary-dark transition-colors"
            size={35}
            onClick={handleMetricsClick}
          />
          <PersonAdd
            className="cursor-pointer text-primary hover:text-primary-dark transition-colors"
            size={33}
            onClick={() => navigate('/manage')}
          />
          <Hdd
            className="cursor-pointer text-primary hover:text-primary-dark transition-colors"
            size={33}
            title="Configure Test Server"
            onClick={() => navigate('/configure-test-server')}
          />
          </>
        )}
        <div className="text-center">{greeting}</div>
      </div>
      <div className="d-flex align-items-center gap-2">
        {showNotifications && isAuthenticated && isTherapist && (
          <span className="therapist-walkthrough-notifications"><NotificationPanel /></span>
        )}
        <img
          src="/images/plasticise-logo.png"
          alt="Logo"
          onClick={handleNavigate}
          className="img-fluid"
          style={{ width: "50px", height: "auto" }}
        />
      </div>
    </div>
  );
};

export default Greeting;